export default {
  data() {
    return {
      searchSchema: [
        {
          label: '文件名称',
          type: 'input',
          itemName: 'fileName',
          allowClear: true,
        },
        {
          label: '创建时间',
          type: 'datePicker',
          itemName: 'uploadTime',
          allowClear: true,
        },
      ],
      searchForm: {
        operator: '',
        fileName: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '文件名称',
          width: 120,
          dataIndex: 'fileName',
        },
        {
          title: '编辑时间',
          width: 220,
          dataIndex: 'updateTime',
        },
        {
          title: '备注',
          width: 220,
          dataIndex: 'remark',
        },
        {
          title: '文件链接',
          width: 220,
          dataIndex: 'filePath',
          scopedSlots: { customRender: 'filePath' },
        },
        {
          title: '编辑人ITCode',
          width: 180,
          dataIndex: 'operator',
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
